import React, { createContext, useContext } from "react";
import type { IRowSelectionConfig } from "./FilteredTable.types";

export interface FilteredTableSelectionContextValue extends IRowSelectionConfig {
  getRowId: (row: any) => string;
  pageRowIds: string[];
  selectablePageRowIds: string[];
}

const FilteredTableSelectionContext =
  createContext<FilteredTableSelectionContextValue | null>(null);

export function FilteredTableSelectionProvider({
  value,
  children,
}: {
  value: FilteredTableSelectionContextValue | null;
  children: React.ReactNode;
}) {
  return (
    <FilteredTableSelectionContext.Provider value={value}>
      {children}
    </FilteredTableSelectionContext.Provider>
  );
}

export function useFilteredTableSelection(): FilteredTableSelectionContextValue | null {
  return useContext(FilteredTableSelectionContext);
}
